/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for anypurpose without the express written permission of Honeywell. */

import { IProps2 } from "./FilterOption";

export function getAppCheckBoxCount(
  AppValues: React.MutableRefObject<IProps2[]>,
  option: any
): React.ReactNode {
  return AppValues.current.find((d) => d.app === option.applicationName)
    ?.customerIds.length
    ? AppValues.current.find((d) => d.app === option.applicationName)
        ?.customerIds.length
    : 0;
}
